<template>
    <div>
        <div v-show="!mostrarSubItens">
            <app-tabela
                :itens="contrato.itensContrato"
                :campos="campos"
                :itensPorPagina="itensPorPagina"
                :bordered="false"
                :small="false"
            >
                <template slot="botoes">
                    <div class="d-flex flex-row-reverse mb-3">
                        <btn-emitir-relatorio
                            :contrato="contrato"
                            :dataServicos="dataServicos"
                        ></btn-emitir-relatorio>
                    </div>
                </template>
                <template slot="acoes" slot-scope="data">
                    <span class="text-primary float-left mr-1">
                        <i
                            class="fa fa-info-circle fa-lg icon-button"
                            title="Detalhar Sub-Itens"
                            @click.stop="detalharSubItens(data.itemContratoId)"
                        ></i>
                    </span>
                </template>
                <template slot="valorUnitario" slot-scope="data">
                    <p class="text-right m-0">
                        {{ data.valorUnitario | currency }}
                    </p>
                </template>
                <template slot="saldoValor" slot-scope="data">
                    <p class="text-right m-0">
                        {{ data.saldoValor | currency }}
                    </p>
                </template>
                <template slot="status" slot-scope="data">
                    <app-status
                        :status="data.status == 1 ? 'ATIVO' : 'INATIVO'"
                    ></app-status>
                </template>
            </app-tabela>
        </div>
        <div v-if="mostrarSubItens">
            <sub-itens-contrato
                :itemContrato="itemContrato"
                :contrato="contrato"
                :dataServicos="dataServicos"
                @fecharSubItens="itemContrato = null"
            ></sub-itens-contrato>
        </div>
    </div>
</template>

<script>
import SubItensContrato from './SubItensContrato'
import BtnEmitirRelatorio from './BtnEmitirRelatorio'

export default {
    components: {
        SubItensContrato,
        BtnEmitirRelatorio
    },

    props: {
        contrato: {
            type: Object,
            default: () => {}
        },

        dataServicos: {
            type: Object
        }
    },

    data() {
        return {
            itemContrato: null,
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'ordem',
                    label: 'Nº',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descricao',
                    label: 'Descrição',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'descricaoResumida',
                    label: 'Descrição Resumida',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'descTipoProduto',
                    label: 'Tipo Produto',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'descTipoFaturamento',
                    label: 'Tipo Faturamento',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'descNatureza',
                    label: 'Natureza',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'valorUnitario',
                    label: 'Valor',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'quantidade',
                    label: 'Qtd',
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'saldoValor',
                    label: 'Saldo',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'qtdSubItens',
                    label: 'Qtd SubItens',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'seqRM',
                    label: 'Seq RM',
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true,
                    tdClass: 'text-center'
                }
            ],
            itensPorPagina: 5
        }
    },
    methods: {
        detalharSubItens(itemContratoId) {
            this.itemContrato = this.contrato.itensContrato.filter((item) => {
                return item.itemContratoId === itemContratoId
            })[0]
        }
    },

    created() {},

    computed: {
        mostrarSubItens() {
            return this.itemContrato !== null
        }
    }
}
</script>
